exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content1[data-v-9198ca80]{width:calc(100% - 20px);width:calc(100% - 172px);padding-bottom:20px}.content1[data-v-9198ca80],.content2[data-v-9198ca80]{position:fixed;left:172px;top:0;height:100%;overflow:auto}.content2[data-v-9198ca80]{width:calc(100% - 172px);padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9198ca80","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index.vue
// module id = 06k4
// module chunks = 5